export const union = <T extends any[] | undefined>(...arrays: T[]) => {
  return Array.from(new Set(arrays.reduce((sum, cur) => sum.concat(cur ?? []), [] as any[])));
};
